import { render, staticRenderFns } from "./respond-dialog-view.vue?vue&type=template&id=642dd7ca&"
import script from "./respond-dialog-view.vue?vue&type=script&lang=js&"
export * from "./respond-dialog-view.vue?vue&type=script&lang=js&"
import style0 from "./respond-dialog-view.vue?vue&type=style&index=0&id=642dd7ca&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports